import { DepartmentGroup } from "../../../domain/department";

export interface IDepartmentListSelectorDialogCondition {
  name?: string;
  nonDisplayDepartmentCodes?: string[];
  departmentGroup?: DepartmentGroup;
}

export function instanceOfIDepartmentListSelectorDialogCondition(instance: any): instance is IDepartmentListSelectorDialogCondition {
  // departmentGroupはundefinedもありうるので判定しない
  return instance
    && (instance.name !== undefined)
    && (instance.nonDisplayDepartmentCodes !== undefined);
}
